import { Icon, IconName } from 'component-library/components/icons/Icon';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { colors } from 'component-library/styles/colors';
import React, { useState } from 'react';
import styled from 'styled-components';

import { SERVICES } from '../shared';

const ServicesText = styled(ResponsiveBody)`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ServicesWrapper = styled.div`
  position: relative;
`;

const ServicesDropdown = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  box-shadow: 0px 0px 5px rgba(16, 24, 40, 0.08),
    0px 2px 2px rgba(16, 24, 40, 0.04);
  padding: 16px 16px 12px;
  position: absolute;
  top: calc(100% + 12px);
`;

export const Services = () => {
  const [showServices, setShowServices] = useState(false);

  return (
    <ServicesWrapper>
      <ServicesText
        variant={3}
        medium
        onClick={() => setShowServices((prev) => !prev)}
      >
        Our Platform
        <Icon marginLeft={12} name={IconName.CaretDown} />
      </ServicesText>
      {showServices && (
        <ServicesDropdown>
          {SERVICES.map(({ label, to }, idx) => (
            <LinkWrapper key={idx} to={to}>
              <ResponsiveBody marginBottom={4} variant={3}>
                {label}
              </ResponsiveBody>
            </LinkWrapper>
          ))}
        </ServicesDropdown>
      )}
    </ServicesWrapper>
  );
};
